export * from "./Tabs.settings";
